import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as, ...rest }) => {
  const Comp = as ? motion[as] : motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export const MaskLine = ({ children, index = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.18em] -mb-[0.08em]">
    <motion.span
      className={"block " + className}
      initial={{ y: "120%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay: 0.15 + index * 0.13, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);
